// components/ui/FaterStampIcon.tsx
'use client';
import React, { useId } from 'react';
import FaterLogo from '@/components/ui/FaterLogo';

// A certification seal: a scalloped rosette in champagne gold, a thin inner ring, the Fater knot at
// its heart. Drawn once as a path so it stays crisp from 14px in a table row to a large badge.
const LOBES = 18;
const SEAL_PATH = (() => {
  const point = (angle: number, radius: number) => `${(50 + radius * Math.cos(angle)).toFixed(2)} ${(50 + radius * Math.sin(angle)).toFixed(2)}`;
  const step = (2 * Math.PI) / LOBES;
  let d = `M ${point(-Math.PI / 2, 44)}`;
  for (let i = 0; i < LOBES; i++) {
    const start = -Math.PI / 2 + i * step;
    d += ` Q ${point(start + step / 2, 52)} ${point(start + step, 44)}`;
  }
  return `${d} Z`;
})();

export const FaterStampIcon = ({ size = 16, title = 'Fater recommended', ...props }: { size?: number; title?: string } & React.SVGProps<SVGSVGElement>) => {
  const id = useId().replace(/:/g, '');
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title} {...props}>
      <title>{title}</title>
      <defs>
        <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F6E3A8" />
          <stop offset="0.55" stopColor="#D8B25C" />
          <stop offset="1" stopColor="#A87C2A" />
        </linearGradient>
      </defs>
      <path d={SEAL_PATH} fill={`url(#${id}-gold)`} />
      <circle cx="50" cy="50" r="35" fill="#141414" />
      <circle cx="50" cy="50" r="31.5" fill="none" stroke={`url(#${id}-gold)`} strokeWidth="1.6" />
      <FaterLogo x="27" y="27" width="46" height="46" style={{ color: '#E7C878' }} />
    </svg>
  );
};
